import React from "react";
import Box from "@mui/material/Box";

const ContainerBox: React.FC = ({ children }) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          pl: { xs: "10px", sm: "50px", md: "100px", xl: "130px" },
          mt: "40px",
          pr: { xs: "10px", sm: "50px", md: "100px", xl: "130px" },
          maxWidth: { xs: "100%", sm: "100%", lg: "100%" },
          minHeight: { md: "395px" },
          maxHeight: { md: "587px", xl: "726px" },
          mb: "5px",
        }}
      >
        {children}
      </Box>
    </React.Fragment>
  );
};

export default ContainerBox;
